const getters = {
  sidebar: state => state.app.sidebar,
  device: state => state.app.device,
  token: state => state.user.token,
  avatar: state => state.user.avatar,
  name: state => state.user.name,
  roles: state => state.user.roles,
  permissions: state => state.user.permissions || [], // 用户权限列表
  addRouters: state => state.permission.addRouters,
  routers: state => state.permission.routers,
  totalCount: state => state.user.totalCount,

}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js